import { TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import { TableColumn, TableActions, TableStyles } from "./types";
import { tableHeaderCellStyles, tableActionHeaderCellStyles } from "./styles";

interface GenericTableHeaderProps {
  columns: TableColumn[];
  actions?: TableActions;
  styles?: TableStyles;
  actionsHeaderContent?: React.ReactNode;
  selectionHeaderContent?: React.ReactNode;
}

export function GenericTableHeader({
  columns,
  actions,
  styles,
  actionsHeaderContent,
  selectionHeaderContent,
}: GenericTableHeaderProps) {
  const hasActions = Boolean(actions);
  const hasSelection = selectionHeaderContent != null;

  return (
    <TableHead>
      <TableRow>
        {hasSelection && (
          <TableCell
            align="center"
            padding="checkbox"
            sx={{
              ...tableHeaderCellStyles,
              ...(styles?.header || {}),
            }}
          >
            {selectionHeaderContent}
          </TableCell>
        )}

        {/* Em mobile, coluna de ações vem antes das colunas de dados */}
        {isMobile && hasActions && (
          <TableCell
            align="center"
            sx={{
              ...tableActionHeaderCellStyles,
              ...(styles?.header || {}),
            }}
          >
            <Typography variant="caption" fontWeight={700} letterSpacing="0.06em">
              {actionsHeaderContent ?? "Ações"}
            </Typography>
          </TableCell>
        )}

        {columns?.map((column, index) => (
          <TableCell
            key={`tableHeaderCell-${index}`}
            align={column.align || "left"}
            width={column.width}
            sx={{
              ...tableHeaderCellStyles,
              textAlign: column.align || "left",
              ...(styles?.header || {}),
            }}
          >
            <Typography
              variant="caption"
              fontWeight={700}
              letterSpacing="0.06em"
              textAlign={column.align || "left"}
              display="block"
            >
              {column.column}
            </Typography>
          </TableCell>
        ))}

        {/* Em desktop, coluna de ações vem por último */}
        {!isMobile && hasActions && (
          <TableCell
            align="center"
            sx={{
              ...tableActionHeaderCellStyles,
              ...(styles?.header || {}),
            }}
          >
            <Typography variant="caption" fontWeight={700} letterSpacing="0.06em">
              {actionsHeaderContent ?? "Ações"}
            </Typography>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}
